import { render, staticRenderFns } from "./W2HModal.vue?vue&type=template&id=032badc8&scoped=true&"
import script from "./W2HModal.vue?vue&type=script&lang=js&"
export * from "./W2HModal.vue?vue&type=script&lang=js&"
import style0 from "./W2HModal.vue?vue&type=style&index=0&id=032badc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032badc8",
  null
  
)

export default component.exports